// src/redux-saga/actions/testCaseActionTypes.js

export const FETCH_TESTCASES_REQUEST = 'FETCH_TESTCASES_REQUEST';
export const FETCH_TESTCASES_SUCCESS = 'FETCH_TESTCASES_SUCCESS';
export const FETCH_TESTCASES_FAILURE = 'FETCH_TESTCASES_FAILURE';

export const CREATE_TESTCASE_REQUEST = 'CREATE_TESTCASE_REQUEST';
export const CREATE_TESTCASE_SUCCESS = 'CREATE_TESTCASE_SUCCESS';
export const CREATE_TESTCASE_FAILURE = 'CREATE_TESTCASE_FAILURE';

export const UPDATE_TESTCASE_REQUEST = 'UPDATE_TESTCASE_REQUEST';
export const UPDATE_TESTCASE_SUCCESS = 'UPDATE_TESTCASE_SUCCESS';
export const UPDATE_TESTCASE_FAILURE = 'UPDATE_TESTCASE_FAILURE'; 

export const DELETE_TESTCASE_REQUEST = 'DELETE_TESTCASE_REQUEST';
export const DELETE_TESTCASE_SUCCESS = 'DELETE_TESTCASE_SUCCESS';
export const DELETE_TESTCASE_FAILURE = 'DELETE_TESTCASE_FAILURE';

export const GENERATE_TESTCASE_REQUEST='GENERATE_TESTCASE_REQUEST';
export const GENERATE_TESTCASE_SUCCESS='GENERATE_TESTCASE_SUCCESS';
export const GENERATE_TESTCASE_FAILURE='GENERATE_TESTCASE_FAILURE';

export const PROCESS_TESTCASE_REQUEST='PROCESS_TESTCASE_REQUEST';
export const PROCESS_TESTCASE_SUCCESS='PROCESS_TESTCASE_SUCCESS';
export const PROCESS_TESTCASE_FAILURE='PROCESS_TESTCASE_FAILURE';

export const SET_PROCESS_MODAL_DATA = 'SET_PROCESS_MODAL_DATA';

// Action Creators for Fetching Test Cases
export const fetchTestCasesRequest = ({ page = 1, limit = 10, search = '' } = {}) => ({
  type: FETCH_TESTCASES_REQUEST,
  payload: { page, limit, search },
});

export const fetchTestCasesSuccess = (data) => ({
  type: FETCH_TESTCASES_SUCCESS,
  payload: data,
});

export const fetchTestCasesFailure = (error) => ({
  type: FETCH_TESTCASES_FAILURE,
  payload: error,
});


// Action Creators for Creating Test Cases
export const createTestCaseRequest = ({ data, meta }) => ({
  type: CREATE_TESTCASE_REQUEST,
  payload: { data, meta },
});

export const createTestCaseSuccess = (data) => ({
  type: CREATE_TESTCASE_SUCCESS,
  payload: data,
});

export const createTestCaseFailure = (error) => ({
  type: CREATE_TESTCASE_FAILURE,
  payload: error,
});

// Action Creators for Updating Test Cases
export const updateTestCaseRequest = (testCaseId, testCaseData, meta) => ({
  type: UPDATE_TESTCASE_REQUEST,
  payload: { testCaseId, testCaseData, meta },
});

export const updateTestCaseSuccess = (data) => ({
  type: UPDATE_TESTCASE_SUCCESS,
  payload: data,
});

export const updateTestCaseFailure = (error) => ({
  type: UPDATE_TESTCASE_FAILURE,
  payload: error,
});

// Action Creators for Deleting Test Cases
export const deleteTestCaseRequest = ({ testCaseId, meta }) => ({
  type: DELETE_TESTCASE_REQUEST,
  payload: { testCaseId, meta },
});

export const deleteTestCaseSuccess = (testCaseId) => ({
  type: DELETE_TESTCASE_SUCCESS,
  payload: testCaseId,
});

export const deleteTestCaseFailure = (error) => ({
  type: DELETE_TESTCASE_FAILURE,
  payload: error,
});

// Action Creators for generate Test Cases
export const generateTestCaseRequest = (testCaseData) => ({
  type: GENERATE_TESTCASE_REQUEST,
  payload: testCaseData,
});


export const generateTestCaseSuccess = (data) => ({
  type: GENERATE_TESTCASE_SUCCESS,
  payload: data,
});

export const generateTestCaseFailure = (error) => ({
  type: GENERATE_TESTCASE_FAILURE,
  payload: error,
});


// Action Creators for process Test Cases

export const processTestCaseRequest = ({ agentId, modelName }) => ({
  type: PROCESS_TESTCASE_REQUEST,
  payload: { agentId, modelName },
});


export const processTestCaseSuccess = (data) => ({
  type: PROCESS_TESTCASE_SUCCESS,
  payload: data,
});


export const processTestCaseFailure = (error) => ({
  type: PROCESS_TESTCASE_FAILURE,
  payload: error,
});

export const setProcessModalData = (data) => ({
  type: SET_PROCESS_MODAL_DATA,
  payload: data,
});
